<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="page_title">詳細資料</div>
          <div class="page_subtitle">{{ subtitle }}</div>
          <div class="portlet_wrapper">
            <div class="cnt_block">
              <div class="table_holder">
                <table>
                  <thead>
                    <tr> <th>名稱</th> <th>編輯</th> <th>查看</th> <th>紙本檔</th> </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>實習機構評估表</td>
                      <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('edit')">編輯</router-link> </td>
                      <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('view')">查看</router-link> </td>
                      <td> <router-link class="d-inline-block btn--pill pill aqua" :to="detailPath('file')">上傳/下載</router-link> </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'TeachersEnterpriseFormsContent',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('pages/teachers', [
      'currentTeacherGetter',
      'currentEnterprisesListGetter',
    ]),
    subtitle () {
      const curEnterprise = this.currentEnterprisesListGetter.find(e => e.enterprise_id == this.$route.params.id);
      if(!curEnterprise) return "-";
      return curEnterprise.enterprise_name;
    },
  },
  async created () {
     await this.getEnterprisesList('');
  },
  methods: {
    ...mapActions('pages/teachers', [
      'getEnterprisesList',
    ]),
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    detailPath(type) {
      return `/teachers/enterprise/${this.$route.params.id}/${type}`;
    },
  }
}
</script>
